import { Component, HostBinding, Input } from '@angular/core';

import { EventModel } from '@frontend/sports/betting-offer/feature/model';

import { BetBuilderTrackingValues } from '../bet-builder/bet-builder-tracking';
import { BetBuilderPrecreatedModel } from '../bet-builder/model/bet-builder.model';
import { BetBuilderConfigService } from '../bet-builder/services/bet-builder-config.service';

enum BetBuilderDisplayType {
    Classic,
    EntainUIInMarketBoard,
    EntainUIInOverlay,
}

@Component({
    selector: 'ms-bet-builder-view',
    standalone: false,
    templateUrl: './bet-builder-view.component.html',
})
export class BetBuilderViewComponent {
    @Input() event: EventModel;
    @Input() preCreated?: BetBuilderPrecreatedModel;
    @HostBinding('class') className = 'tab-bet-builder';

    source = BetBuilderTrackingValues.EventDetails;

    BetBuilderDisplayType = BetBuilderDisplayType;

    constructor(private betBuilderConfigService: BetBuilderConfigService) {}

    get displayType(): BetBuilderDisplayType {
        if (!this.betBuilderConfigService.useBetBuilderInEntainUI(this.event.sport.id)) {
            return BetBuilderDisplayType.Classic;
        }

        if (this.betBuilderConfigService.showEmbeddedUi()) {
            return BetBuilderDisplayType.EntainUIInMarketBoard;
        }

        return this.betBuilderConfigService.showEntainUiInOverlay(this.event.sport.id)
            ? BetBuilderDisplayType.EntainUIInOverlay
            : BetBuilderDisplayType.EntainUIInMarketBoard;
    }
}
